import { FORM_VALUE_ENUM, FORM_VALUE_INTER } from './constant';

export const convert = (data: FORM_VALUE_INTER) => ({
  ...data,
  [FORM_VALUE_ENUM.NAME]: data[FORM_VALUE_ENUM.NAME].trim(),
});
